class T {

  static LANG = undefined;

  static lang() {
    if (!T.LANG) {
      const language = window.navigator.userLanguage || window.navigator.language;
      T.LANG = (!language || language.includes("ja")) ? T.ja : T.en;
    }
    return T.LANG;
  }

  static get(key) {
    return T.lang()[key];
  }

  static en = {
    "backend": "Backend",
    "calculating": "Calculating",
    "clearCache": "Clear Cache",
    "clipBoardNotSupported": "Clipboard is not supported.",
    "confirmClearCache": "Do you want to clear all cached data?",
    "copiedToClipBoard": "Copied sgf to clipboard",
    "copiedLinkToClipBoard": "Copied sgf link to clipboard",
    "copy": "Copy",
    "encoding": "Encoding",
    "ExplorationBecomeEffective": "This change will become effective from the next move.",
    "fontSize": "Font size",
    "gameInfoPB" : "Black Player",
    "gameInfoPW" : "White Player",
    "gameInfoBR" : "Black Rank",
    "gameInfoWR" : "White Rank",
    "gameInfoBT" : "Black Team",
    "gameInfoWT" : "White Team",
    "gameInfoAN" : "Annotator",
    "gameInfoCP" : "Copyright",
    "gameInfoDT" : "Date",
    "gameInfoEV" : "Event",
    "gameInfoGN" : "Game Name",
    "gameInfoGC" : "Game Comment",
    "gameInfoON" : "Opening",
    "gameInfoOT" : "Overtime",
    "gameInfoPC" : "Place",
    "gameInfoRE" : "Result",
    "gameInfoRO" : "Round",
    "gameInfoRU" : "Rule",
    "gameInfoSO" : "Source",
    "gameInfoTM" : "Time Limits(sec)",
    "gameInfoUS" : "User",
    "gameInfoHA" : "Handicap",
    "gameInfoKM" : "Komi",
    "hideLessVisits": "Hide less visits",
    "linkHome": "FujiGoban Home",
    "linkNews": "News",
    "linkTweets": "Tweets",
    "linkYouTube": "YouTube",
    "linkBook": "New books",
    "linkLicense": "Licence",
    "loadModelError": "Loading model failed. Try later.",
    "maxDatabaseCacheSize": "Number of cache",
    "model": "Model",
    "move": "Move",
    "moveNumber": "Move number",
    "new": "New",
    "nodesPerMove": "Nodes/move",
    "numOfVariations": "Number of variations to show",
    "open": "Open",
    "pass": "Pass",
    "paste": "Paste",
    "ponder": "Ponder",
    "restore": "Restore",
    "save": "Save",
    "share": "Share",
    "trialMove": "Trial move",
    "trialMoveTooltip": "You can save the current board state and restore it later.",
    "used": "used",
    "variation": "Variation",
    "viewModeNode": "None",
    "visits": "Visits",
    "winRate": "Win rate",
  }

  static ja = {
    "backend": "バックエンド",
    "calculating": "計算中",
    "clearCache": "キャッシュ消去",
    "clipBoardNotSupported": "クリップボードが利用できません。",
    "confirmClearCache": "キャッシュデータをすべて消去してよろしいですか？",
    "copiedToClipBoard": "SGFデータをクリップボードにコピーしました",
    "copiedLinkToClipBoard": "棋譜へのリンクをクリップボードにコピーしました",
    "copy": "コピー",
    "encoding": "文字コード",
    "fontSize": "フォントサイズ",
    "gameInfoPB": "黒番",
    "gameInfoPW": "白番",
    "gameInfoBR": "黒段級位",
    "gameInfoWR": "白段級位",
    "gameInfoBT": "黒チーム",
    "gameInfoWT": "白チーム",
    "gameInfoAN": "解説者",
    "gameInfoCP": "著作権",
    "gameInfoDT": "日付",
    "gameInfoEV": "棋戦名",
    "gameInfoGN": "対局名",
    "gameInfoGC": "その他",
    "gameInfoON": "布石",
    "gameInfoOT": "秒読み",
    "gameInfoPC": "対局場所",
    "gameInfoRE": "結果",
    "gameInfoRO": "何回戦",
    "gameInfoRU": "ルール",
    "gameInfoSO": "ソース",
    "gameInfoTM": "持ち時間(秒)",
    "gameInfoUS": "記録",
    "gameInfoHA": "置石",
    "gameInfoKM": "コミ",
    "hideLessVisits": "探索数と評価値が比較的少ない候補を非表示",
    "linkHome": "藤碁盤ホームページ",
    "linkNews": "囲碁ニュース",
    "linkTweets": "囲碁ツイート",
    "linkYouTube": "囲碁最新動画 (YouTube)",
    "linkBook": "新刊",
    "linkLicense": "ライセンス",
    "loadModelError": "ダウンロードエラー。しばらくしてからやり直してください。",
    "maxDatabaseCacheSize": "最大キャッシュ数",
    "model": "モデル",
    "move": "着手",
    "moveNumber": "着手番号",
    "new": "新規",
    "nodesPerMove": "1手毎の探索数",
    "numOfVariations": "変化図の表示数",
    "open": "開く",
    "pass": "パス",
    "paste": "貼り付け",
    "ponder": "解析",
    "restore": "復元",
    "save": "保存",
    "share": "シェア",
    "trialMove": "検討",
    "trialMoveTooltip": "検討モード。検討終了後、現在の盤面に戻ります。",
    "used": "使用中",
    "variation": "変化図",
    "viewModeNode": "非表示",
    "visits": "探索数",
    "winRate": "勝率",
    "tips0": "FujiGoban AI はブラウザで動作する簡易囲碁AIです。強さとスピードは劣りますが、誰でも簡単に囲碁AIを使えるようにと思い作りました。",
    "tips1": "Google Chrome で動作確認しています。他のブラウザでうまく動作しない場合は、Chrome もお試しください。",
    "tips2": "局面評価には LeelaZero の学習済みモデルを使用していますが、探索処理は AlphaGo のアルゴリズム等を参考に書いたもので、LeelaZero のプログラム自体を移植したものではありません。",
    "tips3": "長手数のシチョウを読むのは苦手です。解析中に「検討」モードにしてシチョウの図を教えてあげると、AIの理解が少し早くなるかもしれません。",
    "tips4": "コミ7目半、中国ルールに基づく評価値のため、日本ルールでの形勢と一致しないことがあります。",
    "tips5": "変化図の読み込み・保存、19路盤以外には対応していません。",
    "tips6": "スマホでは2本指で碁盤をズームアウトできます。ただし、下に引っ張りすぎると、ブラウザの画面更新になってしまい、碁盤がリセットされます。",
    "tips7": "誤って棋譜を消してしまった場合は「復元」ボタンで以前の棋譜を復元可能な場合があります。",
    "tips8": "対局の途中で一時的に変化図を研究する時は、「検討」にチェックを入れて着手してください。チェックを外すと実戦図に戻ります。",
    "tips9": "AIは計算量が多いためバッテリーの減りが早いです。長時間使用する場合は、充電できる環境でご利用ください。",
    "tips10": "モデルは10b(block)と15bを用意しています。15bの方が1局面の評価に限ってはより正確ですが、軽量の10bの方が探索スピードは速く、同じ時間ならより多くの手を読めます。高性能機種を使用、または時間がたっぷりある方は15bの方も試してみてください。",
    "tips11": "LeelaZero の相対的な強さは、10b=9888、15b=11806、20b=12278、40b=16688 くらいらしいです。20bや40bを使って「神の一手」を追求する方は、高性能パソコンで他のプログラムを使ってください。🙂",
  }
}

export default T;